export default __webpack_public_path__ + "static/media/palm-trimming.32246cc1.jpg";